import React from "react";
import Grid from "components/common/Grid";
import Stack from "components/common/Stack";
import MobileResponsive from "components/common/MobileResponsive";
import DashboardHeader from "../DashboardHeader";
import PortfolioPerformanceCard from "components/Dashboard/PortfolioPerformanceCard";
import StatsContainer from "./Stats";
import StatsMobileAppContainer from "./StatsMobileApp";
import PortfolioAllocationContainer from "./PortfolioAllocation";
import PerformanceChartContainer from "./PerformanceChart";
import SectorDiversificationContainer from "./SectorDiversification";
import MarketCapDiversificationContainer from "./MarketCapDiversification";
import { dateTimeHelper } from "helper/dateTime";
import { tracker } from "library/tracker";
import { withRouter } from "react-router-dom";
import Button from "components/common/Button";
import BacktestYearReturn from "components/Dashboard/BacktestYearReturn";
import { Box, ButtonGroup } from "@mui/material";
import Text from "components/common/Text";
import HeatmapHeader from "components/HeatmapHeader";

const sampleData = [
  { year: 2025, month: "January", portfolioReturns: -4.1 },
  { year: 2025, month: "February", portfolioReturns: 10.9 },
  { year: 2025, month: "March", portfolioReturns: -7.5 },
  { year: 2025, month: "April", portfolioReturns: 0.3 },
  { year: 2025, month: "May", portfolioReturns: 6.8 },
  { year: 2025, month: "June", portfolioReturns: -5.2 },
  { year: 2025, month: "July", portfolioReturns: 11.4 },
  { year: 2025, month: "August", portfolioReturns: 4.5 },
  { year: 2025, month: "September", portfolioReturns: 4.5 },
  { year: 2025, month: "October", portfolioReturns: 4.5 },
  { year: 2025, month: "November", portfolioReturns: 4.5 },
  { year: 2025, month: "December", portfolioReturns: 4.5 },

  { year: 2024, month: "January", portfolioReturns: 1.5 },
  { year: 2024, month: "February", portfolioReturns: 12.3 },
  { year: 2024, month: "March", portfolioReturns: -1.1 },
  { year: 2024, month: "April", portfolioReturns: 0.3 },
  { year: 2024, month: "May", portfolioReturns: 0.2 },
  { year: 2024, month: "June", portfolioReturns: 8.9 },
  { year: 2024, month: "July", portfolioReturns: 3.6 },
  { year: 2024, month: "August", portfolioReturns: -5.4 },
  { year: 2024, month: "September", portfolioReturns: 5.4 },
  { year: 2024, month: "October", portfolioReturns: -5.4 },
  { year: 2024, month: "November", portfolioReturns: 5.4 },
  { year: 2024, month: "December", portfolioReturns: 5.4 },

  { year: 2023, month: "January", portfolioReturns: -8.8 },
  { year: 2023, month: "February", portfolioReturns: -3.1 },
  { year: 2023, month: "March", portfolioReturns: 3.1 },
  { year: 2023, month: "April", portfolioReturns: 1.8 },
  { year: 2023, month: "May", portfolioReturns: -10.4 },
  { year: 2023, month: "June", portfolioReturns: 1 },
  { year: 2023, month: "July", portfolioReturns: 0.9 },
  { year: 2023, month: "August", portfolioReturns: 1.9 },
  { year: 2023, month: "September", portfolioReturns: 1.9 },
  { year: 2023, month: "October", portfolioReturns: 1.9 },
  { year: 2023, month: "November", portfolioReturns: 1.9 },
  { year: 2023, month: "December", portfolioReturns: 1.9 },
];
const niftySampleData = [
  { year: 2025, month: "January", portfolioReturns: 2.1 },
  { year: 2025, month: "February", portfolioReturns: 3.9 },
  { year: 2025, month: "March", portfolioReturns: -1.5 },
  { year: 2025, month: "April", portfolioReturns: 1.3 },
  { year: 2025, month: "May", portfolioReturns: 2.8 },
  { year: 2025, month: "June", portfolioReturns: -0.2 },

  { year: 2024, month: "January", portfolioReturns: 1.2 },
  { year: 2024, month: "February", portfolioReturns: 2.1 },
  { year: 2024, month: "March", portfolioReturns: -0.8 },
  { year: 2024, month: "April", portfolioReturns: 0.9 },
  { year: 2024, month: "May", portfolioReturns: 1.7 },
  { year: 2024, month: "June", portfolioReturns: 1.1 },
];

class DashboardOnboardedContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isExpiring: false,
      expireInDays: undefined,
      heatmapType: "portfolio",
    };
  }

  handlePortfolioClick = () => {
    this.setState({ heatmapType: "portfolio" });
  };

  handleNiftyClick = () => {
    this.setState({ heatmapType: "nifty" });
  };

  componentDidMount() {
    // console.log("✅ Dashboard mounted");
    // console.log("Dispatching heatmap saga");
    this.props.getPortfolioHeatmapAction();
    // console.log("After dispatch");

    // this.props.portfolioHeatmap;
    // this.props.portfolioHeatmapLoading;

    this.props.getPortfolioPerformanceAction();

    if (!this.props.isOnboardingInitiallyFetched) {
      this.props.getOnboardingDataAction();
    }
    if (!Object.keys(this.props.profile).lenght) {
      this.props.getProfileAction();
    }
    //event-tracker: Initial -> dashboard_loaded
    tracker.initial.dashboardLoaded();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.profile.expiryDate !== this.props.profile.expiryDate) {
      const { profile } = this.props;
      const { isExpiring, expireInDays } =
        dateTimeHelper.isSubscriptionExpiring(profile.expiryDate);
      this.setState({ isExpiring, expireInDays });
    }
  }

  getAlertWidth = () => {
    const { isMobileVerified, isExpired } = this.props;
    let v = 12;
    if (!isMobileVerified & isExpired) {
      v = 6;
    }
    return v;
  };

  handlePlanAndPricingClick = () => {
    this.props.history.push({
      pathname: "/customer/plan-and-pricing",
      state: {
        returnURI: "/customer/dashboard",
        paymentType: "RENEWAL",
      },
    });
  };

  redirecToInvestMore = () => {
    this.props.history.push("/jarvis-portfolio/invest-more");
  };

  render() {
    const MONTHS = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const normalizeHeatmapData = (data = []) => {
      if (!data.length) return [];

      // 1️⃣ Group by year
      const yearMap = {};

      data.forEach(({ year, month, portfolioReturns }) => {
        if (!yearMap[year]) {
          yearMap[year] = {};
        }
        yearMap[year][month] = portfolioReturns;
      });

      // 2️⃣ Build normalized array
      const normalized = [];

      Object.keys(yearMap)
        .sort((a, b) => b - a) // latest year on top
        .forEach((year) => {
          MONTHS.forEach((month) => {
            normalized.push({
              year: Number(year),
              month,
              portfolioReturns:
                yearMap[year][month] !== undefined ? yearMap[year][month] : "-",
            });
          });
        });

      return normalized;
    };

    const { heatmapType } = this.state;

    const { portfolioHeatmap, portfolioHeatmapLoading } = this.props;

    const rawHeatmapData =
      heatmapType === "portfolio"
        ? portfolioHeatmap?.portfolio || []
        : portfolioHeatmap?.nifty || [];

    const heatmapData = normalizeHeatmapData(rawHeatmapData);

    const { profile, portfolioPerformance, hasPortfolio } = this.props;
    return (
      <Stack sx={{ maxWidth: "100%" }} mb={2}>
        <MobileResponsive
          web={() => (
            <>
              <DashboardHeader />

              <Grid
                container
                spacing={hasPortfolio ? 2 : 0}
                columns={hasPortfolio ? 20 : 0}
              >
                <Grid
                  sx={{
                    border: {
                      xs: "1px solid #EEF0F2",
                      md: "0px solid #EEF0F2",
                    },
                    borderRadius: { xs: "10px" },
                  }}
                  item
                  xs={hasPortfolio ? 0 : 12}
                  md={hasPortfolio ? 12 : 12}
                  mb={2}
                >
                  <StatsContainer halfWidth={hasPortfolio} />
                </Grid>
                {hasPortfolio ? (
                  <Grid
                    item
                    xs={0}
                    md={8}
                    mb={2}
                    sx={{
                      width: "100%",
                      paddingLeft: { xs: "0px", md: "16px" },
                    }}
                  >
                    <PortfolioPerformanceCard data={portfolioPerformance} />
                  </Grid>
                ) : null}
              </Grid>
            </>
          )}
          app={() => (
            <>
              <StatsMobileAppContainer
                heading={`Hi, ${profile.fullName || " User"}`}
              />

              <Grid container>
                {hasPortfolio ? (
                  <Grid item xs={12} md={6} mb={2}>
                    <PortfolioPerformanceCard data={portfolioPerformance} />
                  </Grid>
                ) : null}
              </Grid>
            </>
          )}
        />{" "}
        {/* <- responsive Ends here */}
        {/* nifty data is not coming properly from server */}
        <PerformanceChartContainer />
        <Box>
          <HeatmapHeader
            title="Heat Map Yearly Returns (%)"
            activeTab={heatmapType}
            onPortfolioClick={this.handlePortfolioClick}
            onNiftyClick={this.handleNiftyClick}
          />
          <BacktestYearReturn title="" data={heatmapData} loading={false} />
        </Box>
        <PortfolioAllocationContainer />
        {/* Circle Charts */}
        <Grid container spacing={2} mt={{ md: 0 }}>
          <Grid item xs={12} md={6}>
            <SectorDiversificationContainer />
          </Grid>
          <Grid item xs={12} md={6}>
            <MarketCapDiversificationContainer />
          </Grid>
        </Grid>
        {/* App invest more click */}
        <MobileResponsive
          app={() => (
            <Button
              sx={{
                backgroundColor: "#2B70C5",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "max-content",
                padding: "5px 21px",
                borderRadius: "8px",
                position: "fixed",
                bottom: "calc(70px + var(--safe-area-inset-bottom))",
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: "99",
                cursor: "pointer",
                textTransform: "capitalize",
              }}
              onClick={this.redirecToInvestMore}
            >
              <img
                src="/images/mobileApp/invest-more.svg"
                style={{ marginRight: "8px" }}
                alt="icon"
              />
              Invest More
            </Button>
          )}
        />
      </Stack>
    );
  }
}

export default withRouter(DashboardOnboardedContainer);
